import REST from './Rest'
import StudioSession from './StudioSession'


class StudioRest extends StudioSession {
    constructor(props) {super(props)
        this.REST = new REST()
    }
}


export default StudioRest
